import { render, staticRenderFns } from "./RandomGGTRateTable.vue?vue&type=template&id=14d3ede2&"
import script from "./RandomGGTRateTable.vue?vue&type=script&lang=js&"
export * from "./RandomGGTRateTable.vue?vue&type=script&lang=js&"
import style0 from "./RandomGGTRateTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports